// extracted by mini-css-extract-plugin
export default {"buttons":"PeriodModal_buttons__nAIWk","btn":"PeriodModal_btn__ffIp3","label":"PeriodModal_label__UDZif"};